import { useEffect } from 'react';
import { signalR } from 'src/signalR';

interface UseSignalRProps<T = unknown> {
  methodName: string;
  callback: (data: T) => void;
}

export const useSignalR = <T = unknown,>({ methodName, callback }: UseSignalRProps<T>) => {
  useEffect(() => {
    const wrappedCallback = (...args: unknown[]) => {
      callback(args[0] as T);
    };
    signalR.addListener(methodName, wrappedCallback);

    return () => {
      signalR.removeListener(methodName, wrappedCallback);
    };
  }, [methodName, callback]);

  return signalR;
};
